import { call, put, takeLatest } from 'redux-saga/effects';

import * as dealerConfigActions from 'actions/dealerConfigActions';
import * as navigateActions from 'actions/navigateActions';
import { restClient } from 'config/store/configureStore';
import * as types from 'constants/ActionTypes';
import { createNotification } from 'modules/toast-notifications/actions';

function* fetchDepositPreviewWorker({ payload: { request }, meta }) {
  try {
    const { data } = yield call(restClient.request, request);
    yield put(dealerConfigActions.depositPreviewSuccess(data, meta));
    yield call(navigateActions.redirectTo, data);
  } catch (error) {
    yield put(dealerConfigActions.depositPreviewFailure(error, meta));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'page.fiche.notification.get_keydeposit_preview.failure',
          defaultMessage: 'Cannot get the configuration preview',
        },
      })
    );
  }
}

function* fetchPickupPreviewWorker({ payload: { request }, meta }) {
  try {
    const { data } = yield call(restClient.request, request);

    yield put(dealerConfigActions.pickupPreviewSuccess(data, meta));
    yield call(navigateActions.redirectTo, data);
  } catch (error) {
    yield put(dealerConfigActions.pickupPreviewFailure(error, meta));
    yield put(
      createNotification({
        type: 'error',
        message: {
          id: 'page.fiche.notification.get_keydeposit_preview.failure',
          defaultMessage: 'Cannot get the configuration preview',
        },
      })
    );
  }
}

export default function* DealersSagas() {
  yield takeLatest(types.PICKUP_PREVIEW, fetchPickupPreviewWorker);
  yield takeLatest(types.DEPOSIT_PREVIEW, fetchDepositPreviewWorker);
}
